interface SideNavConfigInterface {
  name: string;
  slug: string;
  hasAddButton?: boolean;
  id?: Number;
}

export const sideNavPrimaryMenu: Array<SideNavConfigInterface> = [
  {
    id: 1,
    name: "Your Skin Space",
    slug: "/store",
  },
  {
    id: 10,
    name: "How to use",
    slug: "/store/how-to-use",
  },
  {
    id: 11,
    name: "Where to buy",
    slug: "/store/where-to-buy",
  },
  {
    id: 13,
    name: "Ingredient Checker",
    slug: "/store/ingredient-checker",
  },
  {
    id: 2,
    name: "Skincare Steps",
    slug: "/store/skincare-steps",
  },
  {
    id: 13,
    name: "Revise Routine",
    slug: "/store/revise-routine",
  },
  {
    id: 3,
    name: "Skin Solution",
    slug: "/store/skin-solution",
  },
  {
    id: 9,
    name: "Skincare Tracker",
    slug: "/store/skincare-tracker",
  },

  // {
  //   id: 3,
  //   name: "Missing Skincare",
  //   slug: "/store/missing-skincare",
  // },
  // {
  //   id: 4,
  //   name: "Holistic Care",
  //   slug: "/store/holistic-care",
  // },

  // {
  //   id: 6,
  //   name: "The Good Stuff",
  //   slug: "/store/the-good-stuff",
  // },
  {
    id: 12,
    name: "Progress Journal",
    slug: "/store/personal-journal",
  },

  {
    id: 8,
    name: "Earn Passive Cash",
    slug: "/store/earn-cash-back",
  },
    {
    id: 5,
    name: "Your Space",
    slug: "/store/liked-your-space",
  },
  {
    id: 7,
    name: "Appreciate You",
    slug: "/store/appreciate-you",
  },
  {
    id: 14,
    name: "Subscription & Billing",
    slug: "/store/subscription",
  },
];
